import React from "react";
import { NavigateFunction } from "react-router-dom";
import { useAppStore } from "../../../../../appStore";
import { OrangeTextButton } from "../../../../common/OrangeTextButton";
import { BulkAlertSettingsDialog, BulkSite } from "./BulkAlertSettingsDialog";

/**
 * "Bulk alert settings" on the Sites list (ENG-2485). Same gate as camera
 * edit (edit_cameras). Uses the selected rows, or every site in the group
 * when nothing is selected.
 */
export const BulkAlertSettingsButton = ({
  selected,
  renderedRows,
  groupName,
  navigate,
}: {
  selected: readonly (string | number)[];
  renderedRows: { id: string | number; name: string }[];
  groupName: string;
  navigate: NavigateFunction;
}) => {
  const { userPermissions } = useAppStore();
  const [open, setOpen] = React.useState(false);
  const [dialogSites, setDialogSites] = React.useState<BulkSite[]>([]);

  if (!userPermissions?.edit_cameras) return null;
  const rows = Array.isArray(renderedRows) ? renderedRows : [];
  if (rows.length === 0) return null;

  const selectedIds = selected.map(String);
  const allSitesInGroup = selectedIds.length === 0;

  const handleOpen = () => {
    const chosen = allSitesInGroup
      ? rows
      : rows.filter((row) => selectedIds.includes(String(row.id)));
    setDialogSites(
      chosen.map((row) => ({ id: Number(row.id), name: String(row.name) }))
    );
    setOpen(true);
  };

  return (
    <>
      <OrangeTextButton
        onClick={handleOpen}
        text="Bulk alert settings"
        disabled={false}
        className="hover:bg-[#E67300] ml-2"
      />
      {open && (
        <BulkAlertSettingsDialog
          open={open}
          onClose={() => setOpen(false)}
          sites={dialogSites}
          groupName={groupName}
          allSitesInGroup={allSitesInGroup}
          navigate={navigate}
        />
      )}
    </>
  );
};
